import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BookCrdtnoteRcptComponent } from '../pages/book-crdtnote-rcpt/book-crdtnote-rcpt.component';
import { DigisubservicesService } from '../services/digisubservices.service';
import { ToWords } from 'to-words';

@Component({
  selector: 'app-book-comm-rcpt',
  templateUrl: './book-comm-rcpt.component.html',
  styleUrl: './book-comm-rcpt.component.scss'
})
export class BookCommRcptComponent {
 crdtNoteData;
  BookBillingData;
  selectedBooks;
  crdtnotetotal = 0;
  toWords;
  crdtnotetotalwords;
  totalamount = 0;
  totalremainingamt = 0;
  crdtnoteamttotal = 0;
  remainingTotal = 0;
  address;
  bookcreditdata;
  crdreturncopies = 0
  payloadArray;
  invTotalAmount = 0;
  invRecvTotalAmount=0;

  constructor(
    public service: DigisubservicesService,
    private dialogRef: MatDialogRef<BookCrdtnoteRcptComponent>,
    @Inject(MAT_DIALOG_DATA) public dataa: any
  ) {
    console.log('bookcrdtnote data', this.dataa);
  }

  ngOnInit(): void {
 
    this.crdtNoteData = this.dataa['data'];
    this.BookBillingData = this.dataa['BookBillingData'];
    this.bookcreditdata = this.dataa['bookcommipricedata'];
    this.selectedBooks = this.dataa['BookBillingData'];

    console.log('selectedBooks',this.selectedBooks);
    console.log("-------------------------------------------");
     console.log('bookcreditdata',this.bookcreditdata);
    for (let i = 0; i < this.selectedBooks.length; i++) {
      let book = this.selectedBooks[i];
          if (book.received_amt) {
              this.crdtnotetotal +=  parseFloat(book.received_amt);
          }
      }
    console.log("crdtnotetotal",this.crdtnotetotal)
    this.toWords = new ToWords();
    this.crdtnotetotalwords = this.toWords.convert(this.crdtnotetotal, {
      currency: true,
    });
    this.address = `${this.BookBillingData[0]['address']} ${this.BookBillingData[0]['taluka']}, ${this.BookBillingData[0]['district']}, ${this.BookBillingData[0]['state']}, ${this.BookBillingData[0]['country']}.`;

    for (
      let index = 0;
      index < Object.keys(this.selectedBooks).length;
      index++
    ) {
      this.totalamount =
        this.totalamount + parseInt(this.selectedBooks[index]['commission']);
      this.crdtnoteamttotal =
        this.crdtnoteamttotal +
        parseInt(this.selectedBooks[index]['received_amt']);

        this.remainingTotal =
        this.remainingTotal + parseInt(this.selectedBooks[index]['remaining_amt']);
        this.totalremainingamt = 
        this.totalremainingamt + parseInt(this.selectedBooks[index]['total_remaining_amt']);
        this.invTotalAmount = 
        this.invTotalAmount + parseInt(this.selectedBooks[index]['invoice_total']);
        this.invRecvTotalAmount = 
        this.invRecvTotalAmount + parseInt(this.selectedBooks[index]['invoice_received_amt']);

    }
  }

  print() {
    window.print();
  }

  save() {

  this.payloadArray = this.BookBillingData.map((billingItem, index) => {
  const bookCredit = this.bookcreditdata[index] || []; // Assuming this is an array of bills

  return {

    id: billingItem.id || null,
    commission_no: this.crdtNoteData.commino,
    date: this.crdtNoteData.date ? new Date(this.crdtNoteData.date).toLocaleDateString('en-CA') : "",
    commission_date: this.crdtNoteData.recptdate ? new Date(this.crdtNoteData.recptdate).toISOString().split('T')[0] : "",
    crdtvno: this.crdtNoteData.crdtvno || "",
    commission: billingItem.commission || "",    
    rep_name: billingItem.rep_name || "",
    book_copies: billingItem.book_copies || "",
    office_rep_name: billingItem.office_rep_name || "",
    book_seller_name: billingItem.receiver_name || "",
    comm_note_total: billingItem.comm_note_total    || 0,
    voc_date: billingItem.voucher_date || "",
    order_no: billingItem.order_no || "",
    invoice_no: billingItem.invoice_no || "",
    // previous_rem: billingItem.total_remaining_amt || 0,
    bill_no: bookCredit
      };
    });

    console.log('payloadarray',this.payloadArray);



    this.service.insertBookPymtCommission(this.payloadArray).subscribe((data) => {
      // console.log({ data });
      setTimeout(() => {
      alert('Commission Note Added Successfully....');
      location.reload();
      this.dialogRef.close();
      }, 1200);
    });
  }

  ConvertToInt(val) {
    return parseInt(val);
  }
}
